export default __webpack_public_path__ + "static/media/bosse.0c332119.svg";